/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_History_TruncatedInputs */

const en_chat_history_truncated = /** @type {(inputs: Chat_History_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long conversation: older context partially forgotten.`)
};

const fr_chat_history_truncated = /** @type {(inputs: Chat_History_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation longue : ancien contexte partiellement oublié.`)
};

const ms_sg2_chat_history_truncated = /** @type {(inputs: Chat_History_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbualan panjang: konteks lama dilupakan separuh.`)
};

/**
* | output |
* | --- |
* | "Long conversation: older context partially forgotten." |
*
* @param {Chat_History_TruncatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_history_truncated = /** @type {((inputs?: Chat_History_TruncatedInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_History_TruncatedInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_history_truncated(inputs)
	if (locale === "fr") return fr_chat_history_truncated(inputs)
	return ms_sg2_chat_history_truncated(inputs)
});